import { render, staticRenderFns } from "./MarketplaceCheckoutStepAddress.vue?vue&type=template&id=1260a550&"
import script from "./MarketplaceCheckoutStepAddress.vue?vue&type=script&lang=js&"
export * from "./MarketplaceCheckoutStepAddress.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceCheckoutStepAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports